import {
  authenticationChannel,
  commonActions,
  sessionManagement
} from '@codametrix/ui-common';

const { activityMonitor } = sessionManagement;

/** Session timer latch only — does not imply recent local input for heartbeat. */
export const setIsActive = (isActive: boolean) => {
  activityMonitor.isActive = isActive;
};

/** Local user input (mousedown/keypress) — session latch plus heartbeat sliding window. */
export const recordActivity = () => {
  activityMonitor.recordActivity();
};

/**
 * Local input in this browsing context: arm heartbeat (`recordActivity`) and notify peers
 * so they can latch ActivityMonitor `isActive` for renew without every peer heartbeating.
 */
export const broadcastWindowActivity = () => {
  recordActivity();
  authenticationChannel.postMessage({
    type: commonActions.AuthenticatedWindow.ACTIVITY,
    payload: true,
    meta: {
      suppressRedux: true
    }
  });
};
